module.exports = __webpack_public_path__ + "img/oufu_100x130x12.prt.d0b1254a.jpg";